module.exports = __webpack_public_path__ + "static/umbraco-00501227824797be2ef646faa346533f.png";